/**
 * Created by jv on 2019-09-11 (10:14).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import WebSocketClient from "Sources/realtime/client";
import GameSessionMessage from "Sources/models/game-session-message";

class GameSessionController {
  constructor(options) {
    this.baseUrl = options.baseUrl;
    if (utils.isNotNull(this.baseUrl) && this.baseUrl.endsWith("/")) this.baseUrl = this.baseUrl.substring(0, this.baseUrl.length - 1);

    this.sessionId = options.sessionId;
    this.asTeacher = options.asTeacher === true;
    this.teamName = options.teamName;

    this.onOpenListeners = [];
    this.onCloseListeners = [];
    this.onErrorListeners = [];
    this.onMessageListeners = [];
  }

  init() {
    if (this.asTeacher) {
      this.url = `${this.baseUrl}/${this.sessionId}?as-teacher=true`;
    } else {
      this.url = `${this.baseUrl}/${this.sessionId}?team-name=${encodeURIComponent(this.teamName)}`;
    }

    this.client = new WebSocketClient({
      url: this.url,
      onOpen: (event) => this._onSessionOpened(event),
      onClose: (event) => this._onSessionClosed(event),
      onError: (event) => this._onSessionError(event),
      onMessage: (event) => this._onSessionMessage(event)
    });
  }

  _onSessionOpened(event) {
    log.cssLog("Successfully established socket connection - %o", event, log.successCss);

    for (let i = 0; i < this.onOpenListeners.length; i++) {
      this.onOpenListeners[i].call(this, event);
    }
  }

  _onSessionClosed(event) {
    log.cssLog("Socket connection was closed - %o", event, log.warningCss);

    for (let i = 0; i < this.onCloseListeners.length; i++) {
      this.onCloseListeners[i].call(this, event);
    }
  }

  _onSessionError(event) {
    log.cssLog("An error occurred on the socket connection - %o", event, log.errorCss);

    for (let i = 0; i < this.onErrorListeners.length; i++) {
      this.onErrorListeners[i].call(this, event);
    }
  }

  _onSessionMessage(event) {
    for (let i = 0; i < this.onMessageListeners.length; i++) {
      this.onMessageListeners[i].call(this, event);
    }
  }

  connect() {
    if (utils.isNotNull(this.client)) {
      this.client.open();
    }
  }

  disconnect() {
    if (utils.isNotNull(this.client)) {
      this.client.close();
    }
  }

  sendMessage(message) {
    if (utils.isNotNull(this.client)) {
      let gameSessionMessage;

      if (message instanceof GameSessionMessage) {
        gameSessionMessage = message;
      } else {
        gameSessionMessage = new GameSessionMessage({
          data: message
        });
      }

      let serializedData = gameSessionMessage.serialize();

      log.info("Sending message to server: %o\nSerialized: %s", gameSessionMessage, serializedData);

      this.client.sendData(serializedData);
    }
  }

  addEventListener(type, func) {
    if (utils.isNull(type) || !utils.isFunction(func)) return;

    switch (type) {
      case "session-opened":
        this.onOpenListeners.push(func);
        break;
      case "session-closed":
        this.onCloseListeners.push(func);
        break;
      case "session-error":
        this.onErrorListeners.push(func);
        break;
      case "session-message":
        this.onMessageListeners.push(func);
        break;
    }
  }
}

export default GameSessionController;



// WEBPACK FOOTER //
// ./app/js/controllers/game-session-controller.js